import SignReleaseView from '@/views/talent/signReleaseView.vue';

export const releaseRoutes = [
  {
    path: '/sign-release',
    name: 'TalentSignRelease',
    component: SignReleaseView,
    meta: { guest: true }, // You can modify this as needed
  },
];
